import React, { useEffect, useState } from "react";

/*
 * Zasłona hasłem na czas pracy nad wersją roboczą.
 *
 * UWAGA — to NIE jest zabezpieczenie. Hasło jest wkompilowane w paczkę
 * JavaScriptu, więc każdy, kto otworzy źródło strony, może je odczytać
 * i pominąć ekran. Chodzi wyłącznie o to, żeby przypadkowy gość albo robot
 * wyszukiwarki nie zobaczył niedokończonego serwisu.
 *
 * Jeżeli treść ma być naprawdę niedostępna, załóż uwierzytelnianie po stronie
 * serwera WWW (Basic Auth) — instrukcja w README obok.
 *
 * Włączenie: ustaw REACT_APP_SITE_PASSWORD przed budowaniem. Brak zmiennej
 * (czyli produkcja) całkowicie wyłącza ten komponent.
 */

const PASSWORD = process.env.REACT_APP_SITE_PASSWORD || "";
const KEY = "prawly_gate_v1";

export default function SiteGate({ children }) {
  const [open, setOpen] = useState(
    () => !PASSWORD || localStorage.getItem(KEY) === PASSWORD
  );
  const [value, setValue] = useState("");
  const [err, setErr] = useState(false);

  /* Wersja robocza nie ma trafić do wyszukiwarek. */
  useEffect(() => {
    if (!PASSWORD) return undefined;
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  if (open) return children;

  const submit = (e) => {
    e.preventDefault();
    if (value === PASSWORD) {
      localStorage.setItem(KEY, value);
      setOpen(true);
    } else {
      setErr(true);
      setValue("");
    }
  };

  return (
    <div className="gate">
      <form className="gate-card" onSubmit={submit}>
        <div className="gate-logo">
          prawly<span>.</span>
        </div>
        <h1>Wersja robocza</h1>
        <p>
          Serwis jest w przygotowaniu. Podaj hasło dostępu, żeby zobaczyć bieżącą
          wersję.
        </p>

        <label htmlFor="gate-pw">Hasło dostępu</label>
        <input
          id="gate-pw"
          type="password"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setErr(false);
          }}
          autoFocus
          autoComplete="current-password"
        />
        {err && <p className="error">Nieprawidłowe hasło.</p>}

        <button className="btn wax">Wejdź</button>
      </form>
    </div>
  );
}
